export default __webpack_public_path__ + "static/media/w_mas_2026_h.379d16a9.jpg";